import { TypographyType } from '@/common/components/base/typography/Typography.type.ts';
import { styled } from 'styled-system/jsx';

const Typography = ({
  textStyle = 'b1',
  color = 'black-1',
  children,
  ...props
}: TypographyType) => {
  return (
    <styled.p textStyle={textStyle} color={color} {...props}>
      {children}
    </styled.p>
  );
};
export default Typography;
